import { TutorProductService } from "@/common/api.service";
import { FETCH_TUTOR_PRODUCTS, TUTOR_PRODUCT_SUBSCRIBE, RESET_STATE } from "./actions.type";
import { SET_TUTOR_PRODUCTS, SET_ERROR,STATE_RESET } from "./mutations.type";

const initialState = () => {
    return {
        tutorproducts: [],
        tutorproducterrors:[],
    }
}

let state = initialState()

const getters = {
    tutorproducts(state) {
        return state.tutorproducts
    }
}

const actions = {
    async [FETCH_TUTOR_PRODUCTS](context, slug) {
        const { data } = await TutorProductService.get(slug)
        context.commit(SET_TUTOR_PRODUCTS, data.data)
        return data;
    },
    async [TUTOR_PRODUCT_SUBSCRIBE](context,params){
        return TutorProductService.subscribe(params.id,params)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR, ( error.response.data.hasOwnProperty('errors') ?  error.response.data.errors :  error.response.data.message));
          return error
        });
    },

    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_TUTOR_PRODUCTS](state, tpdata) {
        state.tutorproducts = tpdata
    },
    [SET_ERROR](state, error) {
        state.tutorproducterrors = error;
    },  
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};

